<template>
  <div class="meeting-checkout-summary">
    <HMFixedAspectRatioContainer class="img-container">
      <MeetingTypeThumbnail v-if="meetingType.cover_photo?.image_url" :meetingType="meetingType" />
      <div v-else>
        <div class="d-flex flex-column position-relative rounded bg-brand-color h-100">
          <div
            class="position-absolute position-top placeholder-icon d-flex align-items-center justify-content-center rounded-circle bg-white">
            <i class="far fa-calendar c-brand-color"></i>
          </div>
          <div class="position-absolute position-bottom d-flex justify-content-start align-items-center">
            <h3 class="c-white line-clamp-2">{{ meetingType.name }}</h3>
          </div>
        </div>
      </div>
    </HMFixedAspectRatioContainer>
    <div class="my-3">
      <div class="d-flex flex-row justify-content-start align-items-center">
        <HMInstructorsStack :instructors="meetingType.instructors" :size="'50px'" :clickable="true" />
        <span class="c-charcoal ms-3">{{ instructorNames }}</span>
      </div>
      <hr />
    </div>
    <div class="my-3">
      <h3 class="c-charcoal">{{ meetingType.name }}</h3>
      <span class="h5 c-dark-gray">{{ timezonedTimeslot }}</span>
      <hr />
    </div>
    <div class="my-3">
      <div class="d-flex flex-row justify-content-between align-items-center">
        <span class="">{{ $t('MARKETING.LABELS.TOTAL') }}</span>
        <span class="h3 c-charcoal">{{ $formatCurrency(meetingType.price, currency) }}</span>
      </div>
    </div>
  </div>

</template>

<script>
import MeetingTypeThumbnail from '@/components/marketing/MeetingTypeThumbnail.vue';
import HMFixedAspectRatioContainer from '@/components/common/HMFixedAspectRatioContainer.vue';
import HMInstructorsStack from '@/components/common/HMInstructorsStack.vue';

export default {
  name: 'MeetingCheckoutSummary',
  components: {
    MeetingTypeThumbnail,
    HMFixedAspectRatioContainer,
    HMInstructorsStack
  },
  props: {
    meetingType: {
      type: Object,
    },
    currency: {
      type: String,
    },
    instructorNames: {
      type: String,
    },
    selectedSlot: {
      type: Object,
    },
    timezone: {
      type: String,
    },
  },
  computed: {
    timezonedTimeslot() {
      if (!this.selectedSlot || !this.timezone) return '';
      try {
        return `${this.$formatDate(this.selectedSlot.tz(this.timezone), 'date-time-long')} (${this.timezone.replace('_', ' ')})`
      } catch (error) {
        console.error(error);
        try {
          return `${this.$formatDate(this.selectedSlot.toDate(), 'date-time-long')}`
        } catch (error) {
          console.error(error);
        }
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/components-variables.scss';

.meeting-checkout-summary {
  .img-container {
    flex-shrink: 0;
    width: 300px;
  }
  &.mobile {
    .img-container {
      @include media-breakpoint-only(xs) {
        width: 100%;
      }
    }
  }
}

.placeholder-icon {
  width: 36px;
  height: 36px;
}

.position-top {
  top: 1.5rem;
  right: 1.5rem;
}

.position-bottom {
  bottom: 1rem;
  left: 1.5rem;
  max-width: 200px;
}

.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>

